export const campaignIdsWithExpirationDate: number[] = [36];
